const Main = () => {
  return <div> Bem-vindo ao dashboard do Cardio4all </div>;
};

export default Main;
